import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GraphQLHelper {
    /**
     * @description Construye campos de GraphQL de manera dinamica basandose en una lista de campos con notacion de punto
     * @param fields Array de strings con notacion de punto (ej: ['id', 'name', 'address.city', 'address.country'])
     * @returns String formateado para usar en queries GraphQL
     * @example
     * buildGraphQLFields(['id', 'name', 'address.city', 'address.country'])
     * // Retorna:
     * //   id
     * //   name
     * //   address {
     * //     city
     * //     country
     * //   }
     */
    buildGraphQLFields = (fields: string[]): string => {
        const tree: any = {};

        for (const field of fields) {
            const parts = field.split('.');
            let current = tree;

            for (let i = 0; i < parts.length; i++) {
                const part = parts[i];
                if (!current[part]) {
                    current[part] = {};
                }
                current = current[part];
            }
        }

        const build = (node: Record<string, any>, indent = 2): string => {
            return Object.entries(node)
                .map(([key, value]) => {
                    if (Object.keys(value).length === 0) {
                        return ' '.repeat(indent) + key;
                    }
                    return (
                        ' '.repeat(indent) +
                        key +
                        ' {\n' +
                        build(value, indent + 2) +
                        '\n' +
                        ' '.repeat(indent) +
                        '}'
                    );
                })
                .join('\n');
        };
        return build(tree);
    };
}
